
import { useRef, useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { LoginMethods } from '../../methods';
import { BtnLoader } from '../../components';
import { toast } from 'react-toastify';

export const Login = () => {
    const formRef: any = useRef()
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [displayBtn, setDisplayBtn] = useState(false)
    const [displayForm, setDisplayForm] = useState(false)

    const handelLogin = async (e: any) => {
        e.preventDefault()
        let qr_code = searchParams.get('qr');
        LoginMethods(e, formRef, navigate, setDisplayBtn, qr_code)
    }


    return (
        <div className='w-full h-screen  relative flex items-center justify-center flex-col'>
            <span className='w-full h-[40%] absolute left-0 right-0 top-0 bg-dayan-orange-50 shadow-lg rounded-b-xl' />
            <div className='w-[80%] max-w-[600px] min-h-[320px] bg-white rounded-xl flex z-[1] shadow flex justify-center items-center'>
                <form onSubmit={handelLogin} ref={formRef} className='w-[90%] flex flex-col  items-center py-[20px]'>
                    <img src='/assetes/logo/logo.png' className='w-[110px]' />
                    <input name='username' type='text' placeholder='شماره پرسنلی' className='w-full h-[40px] mt-[20px] px-[10px] border-b-2 border-dayan-orange-50 focus:outline-none' />
                    <input name='password' type='password' placeholder='رمز عبور' className='w-full h-[40px] mt-[20px] px-[10px] border-b-2 border-dayan-orange-50 focus:outline-none' />
                    {displayBtn ?
                        <button type='button' className='w-full h-[44px] bg-dayan-orange-50 text-white rounded-md mt-[20px] relative flex items-center justify-center'>
                            <BtnLoader />
                        </button>
                        :
                        <button type='submit' className='w-full h-[44px] bg-dayan-orange-50 text-white rounded-md mt-[20px] relative flex items-center justify-center'>
                            <span>ورود به سامانه</span>
                        </button>
                    }
                </form>
            </div>

        </div>
    )
}